import GlobalProps from './GlobalProps';

export default GlobalProps;
